export default __webpack_public_path__ + "static/media/healthcare1.99371744.png";